<template>
    <div>
        <MobileTitleWithBack>
            Profile Settings
        </MobileTitleWithBack>
        <v-tabs
            :optional="$vuetify.breakpoint.xsOnly"
            vertical
            grow
        >
            <v-tab
                to="/profile/user-info"
                :class="[$vuetify.breakpoint.xsOnly ? 'smallDeviceFont' : '', $vuetify.breakpoint.smAndUp && selectedTab === 'user-info' ? 'v-tab--active': '']"
            >
                User Information
                <v-spacer />
                <v-btn
                    v-if="$vuetify.breakpoint.xsOnly"
                    icon
                >
                    <v-icon class="material-icons-outlined">
                        chevron_right
                    </v-icon>
                </v-btn>
            </v-tab>
            <v-tab
                to="/profile/change-password"
                :class="$vuetify.breakpoint.xsOnly ? 'smallDeviceFont' : ''"
            >
                Change Password
                <v-spacer />
                <v-btn
                    v-if="$vuetify.breakpoint.xsOnly"
                    icon
                >
                    <v-icon class="material-icons-outlined">
                        chevron_right
                    </v-icon>
                </v-btn>
            </v-tab>
            <v-tab
                to="/profile/email"
                :class="$vuetify.breakpoint.xsOnly ? 'smallDeviceFont' : ''"
            >
                Email
                <v-spacer />
                <v-btn
                    v-if="$vuetify.breakpoint.xsOnly"
                    icon
                >
                    <v-icon class="material-icons-outlined">
                        chevron_right
                    </v-icon>
                </v-btn>
            </v-tab>
            <v-tab
                to="/profile/alert-preferences"
                :class="$vuetify.breakpoint.xsOnly ? 'smallDeviceFont' : ''"
            >
                Alert Settings
                <v-spacer />
                <v-btn
                    v-if="$vuetify.breakpoint.xsOnly"
                    icon
                >
                    <v-icon class="material-icons-outlined">
                        chevron_right
                    </v-icon>
                </v-btn>
            </v-tab>
        </v-tabs>
    </div>
</template>
<script>
import MobileTitleWithBack from '@/components/MobileTitleWithBack';
export default {
    components: {
        MobileTitleWithBack,
    },
    props: {
        selectedTab: {
            type: String,
            default: '',
        },
    },
};
</script>
<style scoped>
    .v-tab {
        justify-content: start;
        text-transform: none !important;

        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px;
        letter-spacing: 0.001em;
        text-align: left;
    }
    .smallDeviceFont {
        color: var(--ll-text-primary) !important;
    }
    .v-tabs a {
        margin-bottom: 2px;
        background-color: var(--ll-surface-subtle);
    }
    .v-tab--active {
        color: var(--ll-text-brand) !important;
        background-color: #F0F6FF !important;
    }
</style>
